// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found-background-layer_container__s7MlW","item":"not-found-background-layer_item__x5bu1","image":"not-found-background-layer_image__34nS1"};